<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">REPRESENTACIÓN (HASTA LOS ÚLTIMOS 2 AÑOS) </legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿Actúa a nombre de otra persona física o moral como representante? <b-button class="btn-popover" v-b-popover.hover.top="info.representacion"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de la representación de la pareja o dependientes económicos no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Datos de la representación</legend>
          <div class="col-md-12 form-group">
            <label class="control-label">Señalar quien tiene la representación <b-button class="btn-popover" v-b-popover.hover.top="info.representante"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="representante" v-validate="'required'" v-model="form_item.representante" label="1" class="d-inline-block">Declarante</p-radio>
            <p-radio name="representante" v-validate="'required'" v-model="form_item.representante" label="2" class="d-inline-block">Pareja</p-radio>
            <p-radio name="representante" v-validate="'required'" v-model="form_item.representante" label="3" class="d-inline-block">Dependiente Económico</p-radio>
          </div>
          <small class="text-danger">{{ errors.first('representante')}}</small>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="control-label">Tipo de representación <b-button class="btn-popover" v-b-popover.hover.top="info.tipo"><i class="far fa-question-circle"></i></b-button></label>
            <!-- <el-select  clearable class="select-default" placeholder="Seleccione una opción" name="tipo" v-validate="'required'" v-model="form_item.tipo_representacion_id">
              <el-option v-for="option in tipos_representacion" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select> -->
            <p-radio name="tipo" v-validate="'required'" v-model="form_item.tipo_representacion_id" label="1" class="d-inline-block">Representante</p-radio>
            <p-radio name="tipo" v-validate="'required'" v-model="form_item.tipo_representacion_id" label="2" class="d-inline-block">Representado</p-radio>
            <small class="text-danger">{{ errors.first('tipo')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipo_representacion_id == 5">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique" v-validate="'required'" v-model="form_item.especifique" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Fecha de inicio de la representación <b-button class="btn-popover" v-b-popover.hover.top="info.fecha"><i class="far fa-question-circle"></i></b-button></label>
            <el-date-picker name="fecha" v-validate="'required'" v-model="form_item.fecha" type="date" placeholder="Seleccione fecha" value-format="dd-MM-yyyy" format="dd-MM-yyyy"></el-date-picker>
            <small class="text-danger">{{ errors.first('fecha')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre de la parte representada <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre" placeholder="Nombre de la parte representada">
            <small class="text-danger">{{ errors.first('nombre')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc')}}</small>
            <small class="text-danger" v-show="validaciones.rfc"> El formato de la CURP no es válido, verifica la información </small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Representante / Representado <b-button class="btn-popover" v-b-popover.hover.top="info.representado"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="representado" class="d-inline-block" v-validate="'required'" v-model="form_item.representado" label="1">Persona física</p-radio>
            <p-radio name="representado" class="d-inline-block" v-validate="'required'" v-model="form_item.representado" label="2">Persona moral</p-radio>
            <small class="text-danger">{{ errors.first('representado')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label"> ¿Recibe remuneración por su representación? <b-button class="btn-popover" v-b-popover.hover.top="info.remunerado"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="remuneracion" class="d-inline-block" v-validate="'required'" v-model="form_item.remuneracion" label="1">SI</p-radio>
            <p-radio name="remuneracion" class="d-inline-block" v-validate="'required'" v-model="form_item.remuneracion" label="2">NO</p-radio>
            <small class="text-danger">{{ errors.first('remuneracion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.remuneracion=='1'">
            <label class="control-label">Monto mensual neto de su representación <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>

            <el-input-number name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0"></el-input-number>
            <!-- <input class="form-control" type="text" name="monto" v-validate="'required'" v-model="form_item.monto" placeholder="Monto mensual"> -->
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Sector productivo al que pertenece</label>
            <el-select  clearable class="select-default" name="sector" v-validate="'required'" filterable placeholder="Seleccione una opción" v-model="form_item.sector_industria_id">
              <el-option v-for="option in sectores_industria" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('sector') }}</small>
          </div>
          <legend>Lugar donde se ubica <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group  col-6">
            <label class="control-label"> País </label>
            <el-select  clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.pais_id==150">
            <label class="control-label"> Entidad Federativa </label>
            <el-select  clearable class="select-default" name="entidad" v-validate="'required'" filterable placeholder="Entidad" v-model="form_item.entidad_federativa_id">
              <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('entidad') }}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.representante="{ item }">
                <div>{{filterDeclarante(item.representante)}}</div>
              </template>
              <template v-slot:item.tipo_representacion_id="{ item }">
                <div>{{filterTipoRepresentante(item.tipo_representacion_id)}}</div>
              </template>
              <template v-slot:item.representado="{ item }">
                <div>{{filterTipoPersona(item.representado)}}</div>
              </template>
              <template v-slot:item.remuneracion="{ item }">
                <div>{{filterBool(item.remuneracion)}}</div>
              </template>
              <template v-slot:item.sector_industria_id="{ item }">
                <div>{{filterSector(item.sector_industria_id)}}</div>
              </template>
              <template v-slot:item.monto="{ item }">
                <div>${{item.monto | currency}}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
    },
    props: ["data"],
    data() {
      return {
        validaciones: {
          rfc_parte: false
        },
        ip_id: 1,
        add_item: false,
        edit_item: null,
        pagado: null,
        bandera: '0',
        isnum: null,
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Representante',
          value: 'representante',
          align: 'center',
        }, {
          text: 'Tipo de representación',
          value: 'tipo_representacion_id',
          align: 'center',
        }, {
          text: 'Fecha de inicio',
          value: 'fecha',
          align: 'center',
        }, {
          text: 'Nombre de la parte representada',
          value: 'nombre',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Representante / Representado',
          value: 'representado',
          align: 'center',
        }, {
          text: 'Remuneración',
          value: 'representado',
          align: 'center',
        }, {
          text: 'Monto mensual neto',
          value: 'monto',
          align: 'center',
        }, {
          text: 'Sector',
          value: 'sector_industria_id',
          align: 'center',
        }, ],
        info: {
          representacion: 'Es cuando el Declarante actúa a nombre de otra persona física o moral (representante) o cuando una persona actúa a nombre del Declarante (representado). Deberá reportar hasta los últimos dos años.',
          representante: 'Señalar quien tiene la representación (representante o representado).',
          tipo: 'Indicar si es representante o representado.',
          fecha: 'Indicar la fecha en que comenzó la representación.',
          representado: 'Seleccionar si es persona física o persona moral.',
          nombre: 'Indicar el nombre o razón social completos de su representante o representado.',
          rfc: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del representante/representado.',
          remunerado: 'Indicar sí o no le pagan por representar a alguien.',
          monto: 'Especificar el monto mensual neto, sin centavos, que percibe por su representación.',
          lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa; o en el extranjero, debiendo señalar el país donde se localiza.',
          sector: 'Elegir el sector al que pertenece.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {
      //...mapFields(["tipo_representacion_id", "nombre_parte_representada", "fecha_nacimiento_parte", "sector_industria_id", "fecha_inicio", "rfc_parte", "curp_parte", "especificar_sector_industria"])
    },
    watch: {},
    methods: {
      showItem() {
        this.add_item = true;
        this.$validator.resume();
        if (!this.form_item.pais_id) {
          //El id Mexico es 150
          this.form_item.pais_id = 150;
        }
      },
      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("representacion", this.form_item).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("representacion/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
      /*  validate() {
         if (this.add_item) {
           this.validaciones = {
             rfc_parte: false
           };
           if (!this.rfcValido(this.form_item.rfc_parte)) {
             this.validaciones.rfc_parte = true;
             return false;
           }
         }
         return this.$validator.validateAll();
       }, */
    },
    created() {
      //this.getLocalidades(97250);
      this.ip_id = this.getKey('uid');
      this.$http.get("representacion/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
    },
    mounted() {
      this.checkCatalogs();
      //El id Mexico es 150
      this.form_item.pais_id = 150;
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/Representacion.vue